module.exports = __webpack_public_path__ + "img/brand-cases20.89b5975a.png";